import {
  PERMISSION_ACTION_ACCEPT,
  PERMISSION_ACTION_COMPLETE,
  PERMISSION_ACTION_FUND,
  PERMISSION_ACTION_REJECT,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ACTION_VOID,
  type PERMISSION_ENTITY_PAAS_OFFER,
  type PermissionAction
} from '@klear/constants'
import {
  ORDER_EVENT_STATUS_ACCEPTED,
  ORDER_EVENT_STATUS_COMPLETED,
  ORDER_EVENT_STATUS_DRAFT,
  ORDER_EVENT_STATUS_FUNDED,
  ORDER_EVENT_STATUS_REJECTED,
  ORDER_EVENT_STATUS_VOIDED
} from '@klear/constants/order-event-status'
import type { OrderEventStatusLabelsFor } from '@klear/order-event-lifecycle/lifecycle'

export const PAAS_OFFER_STATUS_LABELS = {
  [ORDER_EVENT_STATUS_DRAFT]: 'Draft',
  [ORDER_EVENT_STATUS_ACCEPTED]: 'Accepted',
  [ORDER_EVENT_STATUS_FUNDED]: 'Funded',
  [ORDER_EVENT_STATUS_COMPLETED]: 'Completed',
  [ORDER_EVENT_STATUS_REJECTED]: 'Rejected',
  [ORDER_EVENT_STATUS_VOIDED]: 'Voided'
} as const satisfies OrderEventStatusLabelsFor<typeof PERMISSION_ENTITY_PAAS_OFFER>

export const PAAS_OFFER_ACTION_LABELS = {
  [PERMISSION_ACTION_VIEW]: 'View',
  [PERMISSION_ACTION_ACCEPT]: 'Accept',
  [PERMISSION_ACTION_FUND]: 'Fund',
  [PERMISSION_ACTION_COMPLETE]: 'Complete',
  [PERMISSION_ACTION_REJECT]: 'Reject',
  [PERMISSION_ACTION_VOID]: 'Void'
} as const satisfies Partial<Record<PermissionAction, string>>
